import { Callable, Maybe, Optional } from '@vimeo/core/types/generic';

import { liveApplicationConfig } from '../../configs/LiveApplicationConfig';

interface IRegistryEntry {
  name: string;
  period: number;
  callable: Callable;
  callOffset: number;
  calledAt: number;
  callsCount: number;
}

export const intervalsRegistry: Map<number, IRegistryEntry> = new Map();

/**
 * Register interval for further investigation and observing.
 */
export function registerInterval(
  callable: Callable,
  period: number = 0,
  name: string = 'unknown',
): number {
  const id: number = window.setInterval(
    liveApplicationConfig.TIMING.DEBUG_TIMERS
      ? () => {
          const record: Maybe<IRegistryEntry> = intervalsRegistry.get(id);
          const now: number = Date.now();

          callable();

          if (record) {
            intervalsRegistry.set(id, {
              ...record,
              callOffset: record.calledAt ? now - record.calledAt - record.period : 0,
              callsCount: record.callsCount + 1,
              calledAt: now,
            });
          }
        }
      : callable,
    period,
  );

  intervalsRegistry.set(id, { name, period, callable, callOffset: 0, callsCount: 0, calledAt: 0 });

  return id;
}

export function unRegisterInterval(id: Optional<number>): void {
  if (id !== null) {
    intervalsRegistry.delete(id);
    window.clearInterval(id);
  }
}
